<template>
<vue-html2pdf :show-layout="true" :float-layout="false" :enable-download="true" :manual-pagination="true" :filename="filename" :pdf-quality="10" pdf-format="a4" pdf-orientation="portrait" ref="html2Pdf">
    <section slot="pdf-content" id="invoice">
        <div class="container my-5 py-5">
            <div class="d-flex justify-content-center">
                <WhiteLogo />
            </div>
            <div class="text-center border-top border-bottom my-5 py-3">
                <p class="m-0">Invoice No:{{studentForm.invoiceNo}}</p>
                <p class="m-0">Invoice Date: {{studentForm.date}}</p>
            </div>

            <div class="d-md-flex justify-content-between">
                <div>
                    <p class="text-primary">Invoice To</p>
                    <ul class="list-unstyled">
                        <li>ASK3.3 Limited</li>
                        <li>124 City Road, London</li>
                        <li>EC1V 2NX</li>
                    </ul>
                </div>
                <div>
                    <p class="text-primary">Invoice From</p>
                    <b>{{ studentForm.name }}</b>
                    <ul class="list-unstyled">
                        <li><b>Address: </b>{{studentForm.address}}</li>
                        <li><b>UTR: </b>{{studentForm.utr}}</li>
                    </ul>
                </div>
            </div>

            <table v-if="studentForm.payment" class="table border my-5">
                <thead>
                    <tr class="bg-primary-subtle">
                        <th scope="col">No.</th>
                        <th scope="col">Description</th>
                        <th scope="col">Student name</th>
                        <th scope="col">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in studentForm.payment" :key="index">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{ row.invoiceDescription }}</td>
                        <td> {{ row.studentName }}</td>
                        <td> {{ row.money }} £</td>
                    </tr>
                    <tr>
                        <th></th>
                        <td></td>
                        <td class=""><b>Total</b></td>
                        <td style="width: 50px" >{{ paymentTotal }} £</td>
                    </tr>
                </tbody>
            </table>

            <div class="d-md-flex justify-content-between my-5">
                <div>
                </div>
                <div>
                    <h5 class="fw-bold my-4">Payment Info</h5>
                    <ul class="list-unstyled">
                        <li><span class="fw-semibold">Account No: </span> {{ studentForm.account_no }}</li>
                        <li><span class="fw-semibold">Account Name: </span>  {{ studentForm.account_name }} </li>
                        <li><span class="fw-semibold">Sort code: </span> {{ studentForm.short_code }}  </li>

                    </ul>
                </div>


            </div>
        </div>
    </section>
</vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import WhiteLogo from './WhiteLogo.vue'

export default {
    name: 'invoice-pdf',
    components: {
        VueHtml2pdf,
        WhiteLogo
    },
    props: ['studentForm', 'isDownload'],
    data() {
        return {
            isOpen: true
        }
    },
    mounted() {
        if (this.isDownload) {
            this.downloadInvoice()
            this.$router.push('/payment');
        }
    },
    computed: {
        paymentTotal() {
            return this.studentForm.payment.map(student => parseInt(student.money)).reduce((partialSum, a) => partialSum + a);
        },
        filename() {
            return `Invoice_#${this.studentForm.invoiceNo}_${this.studentForm.date}`
        }
    },
    methods: {
        downloadInvoice() {
            this.$refs.html2Pdf.generatePdf()
        }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&amp;display=swap');
.invoice-box {
    max-width: 800px;
    margin: auto;
    padding: 30px;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    line-height: 24px;
    font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
    color: #555;
}

.invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
}

.invoice-box table td {
    padding: 5px;
    vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
    text-align: right;
}

.invoice-box table tr.top table td {
    padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
    font-size: 45px;
    line-height: 45px;
    color: #333;
}

.invoice-box table tr.information table td {
    padding-bottom: 40px;
}

.invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
}

.invoice-box table tr.details td {
    padding-bottom: 20px;
}

.invoice-box table tr.item td {
    border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
    border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: bold;
}

@media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
        width: 100%;
        display: block;
        text-align: center;
    }

    .invoice-box table tr.information table td {
        width: 100%;
        display: block;
        text-align: center;
    }
}

/** RTL **/
.invoice-box.rtl {
    direction: rtl;
    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
}

.invoice-box.rtl table {
    text-align: right;
}

.invoice-box.rtl table tr td:nth-child(2) {
    text-align: left;
}

#invoice {
    font-family:  'Poppins', sans-serif;
    background-color: #fff;
  --bs-font-sans-serif: 'Poppins', sans-serif;
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 2;
  --bs-body-color: #41403E;
  --bs-primary: #0070E4;
  --bs-primary-rgb: 0, 112, 228;
  --bs-border-color: #eeeeee;
}
</style>
